import api from './utilPartner';

const controller = 'ProdutoRede';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  LocalizarParcelaMinimaMaximaPorCodigoPessoa: function (dto) {
    return api.Axios.GetParams(`${url}/LocalizarParcelaMinimaMaximaPorCodigoPessoa`, dto);
  }
});
